<template>
  <div class="aboutus_wrap">
      <!-- <div class="slider_navigation">
        <div class="swiper-button-prev about_prev"><span class="icon-play-flip"></span></div>
        <div class="swiper-button-next about_next"><span class="icon-play"></span></div>
      </div> -->
      <div class="aboutus">        
        <swiper 
         ref="awesomeSwiperA" 
         :options="swiperOption" 
           
         >
        <swiper-slide>
          <div class="slide1">
            <h4>About ProFitX</h4>
            <p>
             Optimize your fantasy rosters with the ProFitX Athlete Pass. Subscriptions come in three packages, access and swap out up to 25 players throughout the season, and include a variety of models, widgets, and real-time/predictive information. 
            </p>
            <div class="btns">
              <router-link to="/pricing" class="btn">Subscribe</router-link>
              <a href="/corporate" class="btn">Explore</a>
            </div>
            <div class="slider_navigation">
        <div class="swiper-button-prev about_prev"><span class="icon-play-flip"></span></div>
        <div class="swiper-button-next about_next"><span class="icon-play"></span></div>
      </div>
          </div>
        </swiper-slide>
          <swiper-slide>
          <div class="slide2">
            <h4>Sports Probability Platform</h4>
            <p>
             The revolutionary Sports Probability Platform will be released at the beginning of the season and was built with the fan in mind.  </p>
            <p>Backtested with over 10 seasons, the accuracy probability currently calculates a winning probability at 66 – 68% for all games for the next 5 days, and 70 – 90% as the game is live.  </p>
            <div class="btns">
              <router-link to="/pricing" class="btn">Subscribe</router-link>
              <a href="/corporate" class="btn">Explore</a>
            </div>
            <div class="slider_navigation">
        <div class="swiper-button-prev about_prev"><span class="icon-play-flip"></span></div>
        <div class="swiper-button-next about_next"><span class="icon-play"></span></div>
      </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide2">
            <h4>Performance Projections & Scouting Tools</h4>
            <!-- <p>Our team synergy lineups show how much better teams can be, their live game analysis & projections rate in real-time, and allow users to see just how well their favorite players work with each other.</p> -->
            <p>AI athlete performance projections shows how well a player is projected to play during pre-match and live game updates.</p>
            <div class="btns">
              <router-link to="/pricing" class="btn">Subscribe</router-link>
              <a href="/corporate" class="btn">Explore</a>
            </div>
            <div class="slider_navigation">
        <div class="swiper-button-prev about_prev"><span class="icon-play-flip"></span></div>
        <div class="swiper-button-next about_next"><span class="icon-play"></span></div>
      </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide3">
            <h4>Synergy Lineups</h4>
            <p>
                Our team synergy lineups show how much better teams can be, their live game analysis & projections rate in real-time, and allow users to see just how well their favorite players work with each other. 
              
            </p>
            <div class="btns">
              <router-link to="/pricing" class="btn">Subscribe</router-link>
              <a href="/corporate" class="btn">Explore</a>
            </div>
            <div class="slider_navigation">
        <div class="swiper-button-prev about_prev"><span class="icon-play-flip"></span></div>
        <div class="swiper-button-next about_next"><span class="icon-play"></span></div>
      </div>
          </div>
        </swiper-slide>
      </swiper>
      
      </div>
      
    </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
   components: { 
      swiper,
      swiperSlide,
    },
    data: () => ({    
      swiperOption: { 
        slidesPerView:1,
        spaceBetween: 20,
        autoHeight: true,        
        navigation: {
          nextEl: ".about_next",
          prevEl: ".about_prev",
        },
        autoplay:{
          delay:8000,
          disableOnInteraction: false
        },
        loop: true, 
      },
    }),

};
</script>